export const configurationRoutes = [
    {
      path: '/configuration',
      component: () => import('../views/Configuration.vue'),
      children: [
        {
          path: '',
          name: 'Opsætning',
          redirect: "users"
        },
        {
          path: 'users',
          name: 'Users',
          component: () => import('../views/Users.vue')
        },   
        {
            path: '/configuration/users/:userId/edit',
            name: 'UserEdit',
            props: true,
            component: () => import('/src/views/User.vue')
        },
        {
            path: '/configuration/users/:userId/password',
            name: 'UserPassword',
            props: true,
            component: () => import('../views/ChangePassword.vue')
        },
        {
            path: '/configuration/users/new',
            name: 'UserNew',
            component: () => import('../views/User.vue')
          },{
          path: 'holidays',
          name: 'Holiday',
          component: () => import('../views/configuration-views/Holiday.vue')
        }, 
        {
          path: 'groups',
          name: 'Groups',
          component: () => import('../views/configuration-views/Groups')
        },       
        {
          path: '/configuration/groups/:groupId/group',
          name: 'GroupConfiguration',
          props: true,
          component: () => import('@/views/group-views/Group.vue')
        },
        {
          path: '/configuration/groups/new',
          name: 'NewGroupConfiguration',
          component: () => import('@/views/group-views/Group.vue')
        },
        {
          path: 'circles',
          name: 'Circles',
          component: () => import('../views/Circles')
        },    
        {
            path: '/configuration/circles/:circleId/edit',
            name: 'CircleEdit',
            props: true,
            component: () => import('../views/Circle.vue')
        },
        {
            path: '/configuration/circles/new',
            name: 'CircleNew',
            component: () => import('/src/views/Circle.vue')
          },
        {
          path: 'agreements',
          name: 'Agreements',
          component: () => import('../views/configuration-views/Agreements')
        },
        {
          path: 'gpsdata',
          name: 'GPSData',
          component: () => import('../views/configuration-views/GPSData')
        },
        {
          path: 'salaryRates',
          name: 'SalaryRates',
          component: () => import('../views/configuration-views/SalaryRates')
        },
      ]
    },
  ];
  
  console.log("configurationRoutes" + configurationRoutes);